import SaveCloseModalTemplate from './SaveCloseModalTemplate';

const ConfirmModal = ({ handler, title, button, text, isSaveBtnVisible }) => {
	return (
		<SaveCloseModalTemplate
			title={title || button}
			saveBtnTitle={button}
			onSave={handler}
			isSaveBtnVisible={isSaveBtnVisible}
		>
			<span>{text}</span>
		</SaveCloseModalTemplate>
	);
};

export default ConfirmModal;
